import Util from '../../../../../shared/util/util';
import {type TimeRegType} from '../../TimeRowUtils';

export type TimeReg = {
	id: string;
	notes: string;
	minutesRegistered: number;
	billableMinutesRegistered: number;
	year: number;
	month: number;
	day: number;
	task?: {
		id: string;
		project: {
			id: string;
		};
	};
	idleTime?: {
		id: string;
	};
	project?: {
		id: string;
	};
};

export type TimeRegEntity = {
	notes: string;
	id: string;
	timeRegId: string;
	name: string;
	type?: TimeRegType;
	isSuggestion?: boolean;
	showAsSuggestion: boolean;
	disabled?: boolean;
	minutesRegistered: number | undefined; // used by dayview only - rewrite
	billableMinutesRegistered: number | undefined; // used by dayview only - rewrite
	isInternalTime?: boolean; // used by dayview only - rewrite
};

export type TimeRegistrationsForAWeek = [
	TimeRegEdge[],
	TimeRegEdge[],
	TimeRegEdge[],
	TimeRegEdge[],
	TimeRegEdge[],
	TimeRegEdge[],
	TimeRegEdge[]
];

export type TimeRegEdge = {
	node: TimeReg;
};

export const timeRegMatchesEntityId = (timeReg: TimeReg, entityId: string | undefined): boolean => {
	return timeReg?.task?.id === entityId || timeReg?.idleTime?.id === entityId || timeReg?.project?.id === entityId;
};

export const timeRegEntityInIdList = (timeReg: TimeReg, entityIdList: string[]): boolean => {
	return entityIdList.some(entityId => timeRegMatchesEntityId(timeReg, entityId));
};

export const getFormattedValue = (value: number | string | undefined | null): number => {
	return Util.convertTimeInputToMinutes(value, true);
};
